module.exports = __webpack_public_path__ + "img/finance-statistics.e1304683.svg";